import Blanket from '@atlaskit/blanket';
import * as React from 'react';
import Tether from 'react-tether';
import { ITetherOptions } from 'tether';

type ContraintsTo = string | 'window' | 'scrollParent' | HTMLElement;

interface IPopoverProps extends ITetherOptions {
  trigger: React.ReactNode;
  triggerStyle?: React.CSSProperties;
  isOpen: boolean;
  closePopover: () => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  constraints?: {
      to?: ContraintsTo;
      attachment?: string | 'together';
      outOfBoundsClass?: string;
      pinnedClass?: string;
      pin?: boolean | string[];
  }[];
}

export const Popover = (props: IPopoverProps) => {
  const {children, trigger, attachment, targetAttachment, constraints, closePopover, isOpen, containerStyle, ...rest} = props;
  return (<>
      {isOpen && <Blanket
        onBlanketClicked={closePopover}
        isTinted={false}
        canClickThrough={false}
      />}
      <Tether
        attachment={attachment || 'top center'}
        targetAttachment={targetAttachment || 'top center'}
        style={{zIndex: 100000}}
        constraints={constraints || [
          {
            to: 'window',
            attachment: 'together'
          }
        ]}
        renderTarget={(ref) => <div ref={ref as any} style={props.triggerStyle}>{trigger}</div>}
        renderElement={(ref) => <div style={containerStyle} ref={ref as any}>{children}</div>}
        {...rest}
      />
    </>
  );
};
